import axios from 'axios';
import { fetchAssignedPeriodoActividadIds } from './workflow-periodo';

export type { PeriodoActividadWorkflowPeriodo } from './workflow-periodo';

export interface ProfasePeriodoActividadInstanciaRef {
  id: number;
  estado?: string;
  periodoActividad?: {
    id?: number;
    nombre?: string;
    tipoPeriodo?: string;
    numeroPeriodo?: number | null;
  };
  periodo?: {
    id?: number;
    tipo?: string;
    fecha?: string;
    desde?: string;
    hasta?: string;
    numero?: number;
    anio?: number;
    estado?: string;
    descripcion?: string;
  };
}

export interface FetchInstanciasForWorkflowStartResult {
  instancias: ProfasePeriodoActividadInstanciaRef[];
  assignedCatalogIds: number[];
}

const PERIODO_ACTIVIDAD_INSTANCIA_API = 'api/profase-periodo-actividad-instancias';

export { fetchAssignedPeriodoActividadIds };

/** Instancias GENERADO cuyo catálogo periodoActividad está asignado al workflow. */
export async function fetchInstanciasForWorkflowStart(
  workflowId: number,
): Promise<FetchInstanciasForWorkflowStartResult> {
  const assignedCatalogIds = await fetchAssignedPeriodoActividadIds(workflowId);
  if (assignedCatalogIds.length === 0) {
    return { instancias: [], assignedCatalogIds: [] };
  }

  const assignedIds = new Set(assignedCatalogIds);
  const res = await axios.get<ProfasePeriodoActividadInstanciaRef[]>(
    PERIODO_ACTIVIDAD_INSTANCIA_API,
    {
      params: {
        page: 0,
        size: 200,
        estado: 'GENERADO',
        sort: 'id,desc',
      },
    },
  );

  const instancias = (Array.isArray(res.data) ? res.data : []).filter(row => {
    const catalogId = row.periodoActividad?.id;
    return catalogId != null && assignedIds.has(catalogId);
  });

  return { instancias, assignedCatalogIds };
}
